export enum ShipmentState {
  Draft = "DRAFT",
  Published = "PUBLISHED",
}
